module.exports = __webpack_public_path__ + "static/img/jiqiren.3df23a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiqiren.png
// module id = BxKz
// module chunks = 15